import type { App } from 'vue'
import { Icon } from '@iconify/vue'

export const iconify = {
  install: (app: App) => {
    app.component('CIcon', Icon)
  },
}
